import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import icon from './image/upi.png'
import icon2 from './image/direct.png'
import icon3 from './image/direct.png'
import { FaRegUser } from "react-icons/fa";
import { CiBank } from "react-icons/ci";
import './App.css'
const WithdrawalOptions = () => {
  const [selectedOption, setSelectedOption] = useState(null);

  const options = [
    {
      id: 1,
      title: "Withdraw Through UPI",
      icon: icon, // Replace with your actual icon URL
      details: [
        "Minimum withdrawal amount 950",
        "Maximum withdrawal amount 100000",
        "Instant withdrawal within 30sec.",
      ],
    },
    {
      id: 2,
      title: "Bank Transfer",
      icon: icon2, // Replace with your actual icon URL
      details: [
        "Minimum withdrawal amount 950",
        "Maximum withdrawal amount 100000",
        "Instant withdrawal within 30sec.",
      ],
    },
    {
      id: 3,
      title: "QR CODE",
      icon: icon3, // Replace with your actual icon URL
      details: [
        "Minimum withdrawal amount 950",
        "Maximum withdrawal amount 100000",
        "Instant withdrawal within 30sec.",
      ],
    },
  ];

  const handleCardClick = (option) => {
    setSelectedOption(option);
  };

  const handleBackToOptions = () => {
    setSelectedOption(null);
  };

  return (
    <div className="bg-light min-vh-100 py-4">
      {/* Header */}
      <div className="bg-success text-white text-center py-2 mt-2 fw-semibold small">
        COMMISSION 5% : REFERRAL 2% FOR ALL GAMES
      </div>

      {/* Display cards or selected option */}
      {!selectedOption ? (
        <div className="w-100 px-3 mt-4" style={{ maxWidth: "600px", margin: "0 auto" }}>
          {options.map((option) => (
            <div
              key={option.id}
              className="card mb-3 shadow-sm border-0 rounded-3"
              onClick={() => handleCardClick(option)}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex align-items-center">
                <img
                  src={option.icon}
                  alt={option.title}
                  className="me-3 mengo"
                  style={{ width: "100px" }}
                />
                <div>
                  <h6 className="card-title text-success fw-bold">{option.title}</h6>
                  <ul className="list-unstyled mb-0" style={{fontSize:'14px'}}>
                    {option.details.map((detail, idx) => (
                      <li key={idx} className="small text-muted">
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="container mt-4">
          {/* Selected Option Card */}
          <div className="card shadow-sm border-0 rounded-3 mx-auto" style={{ maxWidth: "600px" }}>
            <div className="card-body">

                <div className="container">
                    <div className="row">
                        <div className="col-2 mt-4">
                        <img   src={selectedOption.icon} alt={selectedOption.title} lassName="me-3"style={{ width: "100%", }}
                />
                        </div>
                        <div className="col-8">
                        <div>
                  <h6 className="text-success fw-bold">{selectedOption.title}</h6>
                  <ul className="list-unstyled text-muted small mb-0" style={{fontSize:'12px'}}>
                  <li > Minimum withdrawal amount 950</li>
                  <li >Instant withdrawal within 30sec.</li>
                  </ul>
                </div>
                        </div>

                        <div className="col-2 mt-3">
                        <button className="btn btn-primary"  onClick={handleBackToOptions}>Edit</button>

                        </div>
                    </div>
                </div>
              <div className="d-flex justify-content-between align-items-center">
             
              
               </div>
            </div>
          </div>

          {/* Form */}
          <div className="mt-4 mx-auto" style={{ maxWidth: "600px" }}>
            <form>
              {/* Account Holder Name */}
              <div className="mb-3">
                <label className="form-label " style={{color:'green', fontSize:'13px'}}>
                <FaRegUser className="me-2"  style={{fontSize:'17px'}} />
                Account holder name (खाता धारक का नाम):
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter account holder name"
                />
              </div>

              {/* UPI ID */}
              <div className="mb-3">
                <label className="form-label " style={{color:'green', fontSize:'13px'}}>
                <CiBank  className="me-2"   style={{fontSize:'17px'}}/>UPI ID (UPI आईडी) || Ex. (9999999999@xyz):
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter UPI ID"
                />
              </div>

              {/* Confirm UPI ID */}
              <div className="mb-3">
                <label className="form-label   "  style={{color:'green', fontSize:'13px'}}>
                <CiBank  className="me-2"   style={{fontSize:'17px'}}/>Confirm UPI ID (कन्फर्म UPI आईडी) 
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Confirm UPI ID"
                />
              </div>

              {/* Coin Balance */}
              <div className="mb-3">
                <label className="form-label  " style={{color:'green', fontSize:'13px'}}>
                  कृपया सही UPI आईडी Ex.(9999999999@xyz) दर्ज करें* <br/>
                 <span  style={{fontWeight:'600', fontSize:'15px'}}> ₹ Coin</span>
                </label>
                <input type="number" className="form-control"   />
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn btn-danger w-100 fw-bold">
                WITHDRAWL SUBMIT
              </button>
            </form>

            {/* Back Button */}
          
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawalOptions;
